import { render } from "./DataManipulation.vue?vue&type=template&id=1e60df6e&scoped=true"
import script from "./DataManipulation.vue?vue&type=script&lang=js"
export * from "./DataManipulation.vue?vue&type=script&lang=js"

import "./DataManipulation.vue?vue&type=style&index=0&id=1e60df6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e60df6e"]])

export default __exports__